import { render, staticRenderFns } from "./visitor_order_detail.vue?vue&type=template&id=661fe47a"
import script from "./visitor_order_detail.vue?vue&type=script&lang=js"
export * from "./visitor_order_detail.vue?vue&type=script&lang=js"
import style0 from "./visitor_order_detail.vue?vue&type=style&index=0&id=661fe47a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports